




















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Tip } from "../../viewmodels/Tip";
import { UserType } from "@/services/LoginService";

@Component({})
export default class extends Vue {
  public collection = app.tipCollection;

  public model: Tip = new Tip({}, this.collection);
  public selectedModel: Tip | null = null;

  public dialog = false;
  public formTitle: string = "Tips";

  public headers = [
    { text: "User Type", value: "user_type" },
    { text: "Tip Percentage", value: "tip_percentage" },
    { text: "Actions", value: "" }
  ];

  public userTypes = [
    { id: UserType.Administrator, name: "Administrator/Owner" },
    { id: UserType.Waiter, name: "Waiter" },
    { id: UserType.Cook, name: "Cook" },
    { id: UserType.Bartender, name: "Bartender" },
    { id: UserType.Driver, name: "Driver" }
  ];

  public rowsPerPageItems = [-1];
  public pagination = {
    rowsPerPage: -1
  };

  public getUserTypeText(id: number) {
    const type = this.userTypes.find(x => x.id === id);
    return type ? type.name : "";
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public close() {
    this.dialog = false;
  }

  public async save() {
    try {
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public add() {
    this.model = new Tip({}, this.collection);
    this.dialog = true;
  }

  public edit(item: Tip) {
    this.model = item;
    this.dialog = true;
  }
}
